import { Tag } from "Domain/Model/Tag/Tag";

export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS';

export const createTagSuccess = (payload: Record<string, Tag> ) => ({
    type: CREATE_TAG_SUCCESS,
    payload,
});